module.exports = __webpack_public_path__ + "img/onePressMicIdle.9820dc3a.svg";